// Záložní obsah přihlašovací stránky, když API ještě neodpovědělo. Editace probíhá v Administraci → Login stránka.
export const FALLBACK_PHOTO = { src: "/team/tym-01.jpg", caption: "Náš tým – Digitální most" };
export const FALLBACK_QUOTE = { text: "Každý hovor je šance někomu pomoct. Dnes jich uděláme spoustu.", by: "" };
export const greeting = () => { const h = new Date().getHours(); return h < 10 ? "Dobré ráno" : h < 18 ? "Dobrý den" : "Dobrý večer"; };
